module.exports = __webpack_public_path__ + "static/media/18ECA46.1783d3bb.jpg";